import { FC, useState } from "react";
import { Avatar as MuiAvatar, Box, Skeleton } from "@mui/material";
import { TAvatar } from "./Avatar.models";
import BadgeWrapper from "./BadgeWrapper";

const Avatar: FC<TAvatar> = ({
  src,
  alt = "Avatar Image",
  initials,
  employeePresence,
  anchorOrigin = { vertical: "bottom", horizontal: "right" },
  size = "42px",
  fontSize = "1.25rem",
  dotSize = "10px",
  avatarSx,
  badgeSx,
  skeletonSx,
}) => {
  const [isLoading, setIsLoading] = useState(!!src);

  return (
    <BadgeWrapper
      employeePresence={employeePresence}
      dotSize={dotSize}
      anchorOrigin={anchorOrigin}
      badgeSx={badgeSx}
    >
      <Box>
        {isLoading && (
          <Skeleton
            sx={{ ...skeletonSx }}
            variant="circular"
            height={size}
            width={size}
          />
        )}
        <MuiAvatar
          src={src}
          alt={alt}
          sx={{
            ...avatarSx,
            ...(isLoading && { display: "none" }),
            width: size,
            height: size,
            fontSize,
          }}
          onLoad={() => setIsLoading(false)}
        >
          {initials}
        </MuiAvatar>
      </Box>
    </BadgeWrapper>
  );
};

export default Avatar;
